module.exports = __webpack_public_path__ + "img/summerHaze.b89e69fa.png";